import React from "react"
import { AppThemeContext } from "../theme/AppThemeProvider"

const useAppTheme = () => React.useContext(AppThemeContext)
export default useAppTheme
